import { AbstractControl, ValidatorFn } from '@angular/forms';
import { VALIDATION_ERROR } from '@models-global/validation-errors';
import { Values } from '@utils-global/type-values';

export function validatorRegexp(
  regexp: RegExp,
  errorKey: Values<typeof VALIDATION_ERROR>
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const result =
      control.value == null ||
      control.value === '' ||
      regexp.test(control.value);
    return result ? null : { [errorKey]: true };
  };
}
